var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('video',{ref:"video",staticClass:"video",class:_vm.facingModeInternal,attrs:{"autoplay":"","playsinline":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }